// extracted by mini-css-extract-plugin
module.exports = {"notification":"index_notification_1DJIQ","linksContainer":"index_linksContainer_5LjZd","link":"index_link_P4b5z"};